import { isWixStaff } from '../auth/user';

function getWizardSessionId() {
  const currentUrl: URL = new URL(window.location.href);

  return currentUrl.searchParams.get('sid');
}

/**
 * https://wix.slack.com/archives/CBJEAGJ9L/p1551177117016400
 */
function getPrefixedWizardSessionId() {
  return `${isWixStaff() ? 'int' : 's'}-${getWizardSessionId()}`;
}

export { getWizardSessionId, getPrefixedWizardSessionId };
